import React, { useMemo, useState } from "react";
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement
} from "@stripe/react-stripe-js";
import "./index.scss";
// import { useHistory } from 'react-router-dom';
// import { useAuth } from "../../contexts/AuthProvider";
import { CreateSubscriptionService, SaveCardService } from "../../services/AdminService";
import { LoadingSpinnerDotted } from "../loading-spinner/Loader";


const useOptions = () => {
    const options = useMemo(
        () => ({
            style: {
                base: {
                    fontSize: "16px",
                    color: "#555",
                    fontFamily: "'Montserrat', sans-serif",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "red"
                }
            }
        })
    );

    return options;
};

const StripeElement = ({ subscriptionData, setShowPaymentModal, setShowStatusModal }) => {
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    // const { authed, currencyData } = useAuth();
    // const history = useHistory();
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        cardNumber: "",
        expiry: "",
        cvc: "",
    });
    const [saveCardCheck, setSaveCardCheck] = useState(true);

    const handleChange = (event, field) => {
        if (event.error) {
            setErrorMessages((prevState) => ({
                ...prevState,
                [field]: event.error.message,
            }));
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                [field]: "",
            }));
        }
    }

    const createSubscription = async () => {
        await CreateSubscriptionService({
            priceId: subscriptionData.priceId,
            productId: subscriptionData.productId,
            type: "stripe",
        }, (res) => {
            if (res.status === 200) {
                // console.log("create Subscription Data==>", res.data);
                if (res.data.success) {
                    handlePaymentCancel();
                    setShowStatusModal({ isOpen: true, type: "success" });
                } else {
                    handlePaymentCancel();
                    setShowStatusModal({ isOpen: true, type: "failure" });
                }

            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const handleSubmit = async event => {
        event.preventDefault();
        if (!stripe || !elements) return;

        setIsProcessing(true);
        try {
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardNumberElement)
            });

            if (error) {
                // console.log("PaymentMethod error payload===>", error);
            } else {
                // console.log("PaymentMethod success payload===>", paymentMethod);
                if (saveCardCheck) {
                    await SaveCardService({ paymentMethodId: paymentMethod?.id }, (res) => {
                        if (res.status === 200) {
                            // console.log("Save card Data==>", res.data);
                            createSubscription();
                        } else {
                            console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                        }
                    });
                }else{
                    createSubscription();
                }
                setShowPaymentModal(false);
            }

        } catch (err) {
            console.error("Unexpected error:", err);
        } finally {
            setIsProcessing(false);
        }
    };

    const handlePaymentCancel = () => setShowPaymentModal(false);
    // console.log("subscriptionData==>", subscriptionData)
    // console.log("saveCardCheck==>", saveCardCheck)

    return (
        <>
            <div className="payment-card-block">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="d-col-input-field col-md-12">
                            <label className="form-label">Card Number</label>
                            <CardNumberElement
                                options={{ ...options, showIcon: true, placeholder: "Card Number" }}
                                onChange={(event) => handleChange(event, "cardNumber")}
                            />
                            {errorMessages.cardNumber && (
                                <p className="errors-msg">{errorMessages.cardNumber}</p>
                            )}
                        </div>

                        <div className="mt-3 d-col-input-field col-md-6">
                            <label className="form-label">Expiration Date</label>
                            <CardExpiryElement
                                options={options}
                                onChange={(event) => handleChange(event, "expiry")}
                            />
                            {errorMessages.expiry && (
                                <p className="errors-msg">{errorMessages.expiry}</p>
                            )}
                        </div>

                        <div className="mt-3 d-col-input-field col-md-6">
                            <label className="form-label">CVC</label>
                            <CardCvcElement
                                options={options}
                                onChange={(event) => handleChange(event, "cvc")}
                            />
                            {errorMessages.cvc && <p className="errors-msg">{errorMessages.cvc}</p>}
                        </div>
                    </div>

                    <div className="mt-3">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="saveCard"
                                checked={saveCardCheck}
                                onChange={(event) => setSaveCardCheck(event.target.checked)}
                            />
                            <label htmlFor="saveCard" className="form-check-label">
                                Save card for future payments
                            </label>
                        </div>
                    </div>

                    <div className="form-btn-groups d-flex justify-content-end mt-3">
                        <button
                            type="button"
                            onClick={handlePaymentCancel}
                            className="btn btn-secondary-color btn-border-color"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={!stripe || isProcessing}
                            className="btn btn-primary-color ms-3"
                        >
                            {isProcessing ? <LoadingSpinnerDotted /> : "Pay Now"}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default StripeElement;